import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

class SubNavBar extends Component {
	shouldComponentUpdate = ({
		onClickBack,
		backText,
		children,
	}) => {
		const lastProps = this.props;

		if (
			!isEqual(!!children, !!lastProps.children)
			|| !!children
			|| !!lastProps.children
		) return true;

		return (
			!isEqual(!!onClickBack, !!lastProps.onClickBack)
			|| !isEqual(!!children, !!lastProps.children)
			|| !isEqual(backText, lastProps.backText)
		);
	}

	render() {
		const {
			backText,
			onClickBack,
			children,
		} = this.props;

		return (
			<div className="sub-nav-bar hidden-print">
				<If condition={!!onClickBack}>
					<button className="btn btn-link" type="button" onClick={onClickBack}>
						<i className="rkf rkf-chevron-left font-size-18 margin-right-10" />
						<span className="font-regular font-size-14">{ backText }</span>
					</button>
				</If>
				<If condition={!!children}>
					<div className="sub-nav-bar-controls">
						{ children }
					</div>
				</If>
			</div>
		);
	}
}

SubNavBar.propTypes = {
	backText    : PropTypes.string,
	onClickBack : PropTypes.func,
	children    : PropTypes.any,
};

SubNavBar.defaultProps = {
	backText    : 'Go back',
	onClickBack : undefined,
	children    : null,
};

export default SubNavBar;
